import { BiErrorCircle } from "react-icons/bi";
import Error from "../Error/Error";
import { useError } from "@/states/common.state";
import { IValidation } from "@/types/all.types";
const Validation = ({
  position,
  type,
  mt,
  mb,
  pl,
  pr,
  data,
  flexType,
  color,
  icon,
  fontWeight,
  bottom,
  isErrorVisible,
  errorInfo
}: IValidation) => {
  const {
    error
  } = useError();
  if (isErrorVisible) {
    return <Error position={position} mt={mt ?? 4} mb={mb ?? 0} pl={pl ?? 0} pr={pr ?? 0} flexType={flexType} color={color} fontWeight={fontWeight} bottom={bottom}>
        {icon && <BiErrorCircle color={color ?? "#F25A29"} size={16} />}

        {errorInfo}
      </Error>;
  }
  return error ? <ul className="p-0" data-sentry-component="Validation" data-sentry-source-file="Validation.tsx">
      {error[type]?.map((err: string) => <li key={err}>
          <Error position={position} mt={mt ?? 4} mb={mb ?? 0} pl={pl ?? 0} pr={pr ?? 0} flexType={flexType} color={color} fontWeight={fontWeight} bottom={bottom}>
            {<BiErrorCircle color={color ?? "#F25A29"} size={16} />}
            {err}
          </Error>
        </li>)}
    </ul> : data?.response?.data?.errors && <Error color={color} mt={mt ?? 4} mb={mb ?? 0} pl={pl ?? 0} pr={pr ?? 0} flexType={flexType} fontWeight={fontWeight} bottom={bottom}>
        {icon && <BiErrorCircle color={color ?? "#F25A29"} size={16} />}
        {data?.response?.data?.errors[type]}
      </Error>;
};
export default Validation;